<div class="bg-gray-50 min-h-screen p-3 sm:p-4 lg:p-6 overflow-x-hidden">
  <div class="mb-6">
    <h1 class="text-2xl font-semibold text-gray-900">Liste des apprenants</h1>
    <p class="text-sm text-gray-500 mt-1">
      Consultez et gérez les apprenants et leurs certifications
    </p>
  </div>

  <div class="bg-white border rounded-xl shadow-sm mb-6 w-full">
    <!-- LIGNE PRINCIPALE : recherche + bouton filtres -->
    <div class="flex items-center gap-2 p-3 filters-bar">
      <div class="relative filters-search">
        <svg
          class="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
            d="m21 21-4.35-4.35M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z"
          />
        </svg>
        <input
          type="text"
          [(ngModel)]="searchValue"
          class="w-full pl-9 pr-3 py-2.5 text-sm border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
          placeholder="Rechercher un apprenant..."
          (input)="filterText($event)"
        />
      </div>

      <button
        (click)="toggleFilters()"
        class="relative flex items-center gap-1.5 px-3 py-2.5 text-sm border rounded-lg hover:bg-gray-50 transition shrink-0"
        [class.bg-blue-50]="filtersOpen"
        [class.border-blue-300]="filtersOpen"
      >
        <svg
          class="w-4 h-4"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M3 4.5h18M6 12h12M10.5 19.5h3"
          />
        </svg>
        <span class="hidden sm:inline">Filtres</span>
        <span
          *ngIf="activeFiltersCount > 0"
          class="flex items-center justify-center w-4 h-4 text-[10px] font-bold text-white bg-blue-600 rounded-full"
        >
          {{ activeFiltersCount }}
        </span>
      </button>

      <!-- BOUTON EXPORT -->

      <div class="relative flex justify-center py-3">
        <!--<button type="button" (click)="openExportMenu()" [disabled]="exportLoading" class="relative flex items-center gap-2
           px-4 py-2.5
           text-sm
           border border-gray-300
           rounded-lg
           bg-white
           hover:bg-gray-50
           transition
           disabled:opacity-50
           disabled:cursor-not-allowed" [class.bg-blue-50]="exportMenuOpen" [class.border-blue-300]="exportMenuOpen">-->

        <!-- LOADING -->
        <!--<svg *ngIf="exportLoading" class="w-4 h-4 animate-spin" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>

            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
          </svg> -->

        <!-- ICON EXPORT -->
        <!--<svg *ngIf="!exportLoading" class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"
              d="M12 3v12m0 0 4-4m-4 4-4-4M5 21h14" />
          </svg>

          <span>
            {{ exportLoading ? 'Export...' : 'Exporter' }}
          </span>

        </button>-->

        <!-- MENU EXPORT -->
        <div
          *ngIf="exportMenuOpen"
          class="absolute top-full left-1/2 -translate-x-1/2 mt-2 w-[760px] max-w-[calc(100vw-16px)] max-h-[calc(100vh-24px)] bg-white border border-gray-200 rounded-xl shadow-xl z-50 overflow-y-auto overflow-x-hidden"
        >
          <!-- HEADER -->
          <div class="px-4 sm:px-5 py-4 border-b bg-gray-50">
            <div class="flex items-center justify-between gap-3">
              <div class="min-w-0">
                <h3 class="text-sm font-semibold text-gray-900">
                  Export Excel
                </h3>

                <p class="text-xs text-gray-500 mt-1">
                  Choisissez les données à exporter.
                </p>
              </div>

              <!-- FERMER -->
              <button
                type="button"
                (click)="exportMenuOpen = false"
                class="flex-shrink-0 w-7 h-7 flex items-center justify-center rounded-lg text-gray-400 hover:bg-gray-200 hover:text-gray-700 transition"
              >
                ✕
              </button>
            </div>
          </div>

          <!-- BODY -->
          <div class="p-4 sm:p-5 grid grid-cols-1 md:grid-cols-2 gap-x-6">
            <!-- COLONNE GAUCHE -->

            <div class="space-y-4">
              <!-- TYPE D'EXPORT -->
              <div>
                <label class="block text-xs font-semibold text-gray-700 mb-1.5">
                  Type d'export
                </label>

                <select
                  [(ngModel)]="exportFlag"
                  class="w-full px-3 py-2.5 text-sm border border-gray-300 rounded-lg bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                >
                  <option [ngValue]="null">Tous les types d'export</option>

                  <option [ngValue]="'CERTIFIED'">Certifiés</option>

                  <option [ngValue]="'ENHANCED'">Renforcés</option>

                  <option [ngValue]="'INSERES'">En situation d'emploi</option>
                </select>
              </div>

              <!-- GENRE -->
              <div>
                <label class="block text-xs font-medium text-gray-600 mb-1.5">
                  Genre
                </label>

                <select
                  [(ngModel)]="exportGender"
                  class="w-full px-3 py-2.5 text-sm border border-gray-300 rounded-lg bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                >
                  <option [ngValue]="null">Tous les genres</option>

                  <option value="FEMALE">Femmes</option>

                  <option value="MALE">Hommes</option>
                </select>
              </div>

              <!-- TYPE DE PARCOURS -->
              <div>
                <label class="block text-xs font-medium text-gray-600 mb-1.5">
                  Type de parcours
                </label>

                <select
                  [(ngModel)]="exportCourseType"
                  (ngModelChange)="onExportCourseTypeChange()"
                  class="w-full px-3 py-2.5 text-sm border border-gray-300 rounded-lg bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                >
                  <option [ngValue]="null">Tous les parcours</option>

                  <option
                    *ngFor="let type of courseTypeOptions"
                    [ngValue]="type"
                  >
                    {{ type }}
                  </option>
                </select>
              </div>

              <!-- CERTIFICAT -->
              <div>
                <label class="block text-xs font-medium text-gray-600 mb-1.5">
                  Certificat
                </label>

                <select
                  [(ngModel)]="exportLabel"
                  [disabled]="!exportCourseType"
                  class="w-full px-3 py-2.5 text-sm border border-gray-300 rounded-lg bg-white disabled:bg-gray-100 disabled:text-gray-400 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                >
                  <option [ngValue]="null">Tous les certificats</option>

                  <option
                    *ngFor="let certificate of certifcateOption"
                    [value]="certificate.name"
                  >
                    {{ certificate.name }}
                  </option>
                </select>

                <p
                  *ngIf="!exportCourseType"
                  class="text-[11px] text-gray-400 mt-1"
                >
                  Sélectionnez d'abord un parcours.
                </p>
              </div>
            </div>

            <!-- COLONNE DROITE -->
            <div class="space-y-4 mt-4 md:mt-0">
              <!-- STATUT -->
              <div>
                <label class="block text-xs font-medium text-gray-600 mb-1.5">
                  Statut
                </label>

                <select
                  [(ngModel)]="exportStatus"
                  class="w-full px-3 py-2.5 text-sm border border-gray-300 rounded-lg bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                >
                  <option [ngValue]="null">Tous les statuts</option>

                  <option value="Étudiant">Étudiant</option>

                  <option value="Entrepreneur / Freelance">
                    Entrepreneur / Freelance
                  </option>

                  <option value="Stagiaire">Stagiaire</option>

                  <option value="Autres">Autres</option>
                </select>
              </div>

              <!-- ÂGE -->
              <div>
                <label class="block text-xs font-medium text-gray-600 mb-1.5">
                  Âge
                </label>

                <select
                  [(ngModel)]="exportAgeRange"
                  class="w-full px-3 py-2.5 text-sm border border-gray-300 rounded-lg bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                >
                  <option [ngValue]="null">Tous les âges</option>

                  <option value="Moins de 36 ans">Moins de 36 ans</option>

                  <option value="36 ans et plus">36 ans et plus</option>
                </select>
              </div>

              <!-- LOCALISATION -->
              <div class="export-location-section">
                <!-- ==================== PAYS ==================== -->
                <div class="mb-4">
                  <label class="block text-xs font-medium text-gray-600 mb-1.5">
                    Pays de lancement
                  </label>

                  <p-dropdown
                    [options]="exportCountries"
                    [(ngModel)]="selectedExportCountry"
                    optionLabel="name"
                    [showClear]="false"
                    appendTo="body"
                    class="export-dropdown"
                    styleClass="export-dropdown-control"
                    (onChange)="onExportCountrySelected($event)"
                  >
                    <!-- Pays sélectionné -->
                    <ng-template pTemplate="selectedItem" let-country>
                      <div class="export-dropdown-value">
                        <!-- Tous les pays -->
                        <span
                          *ngIf="country?.isAll"
                          class="export-location-icon"
                        >
                          🌍
                        </span>

                        <!-- Drapeau du pays -->
                        <span
                          *ngIf="country && !country.isAll && country.isoCode"
                          class="fi"
                          [ngClass]="'fi-' + country.isoCode.toLowerCase()"
                        >
                        </span>

                        <!-- Nom du pays -->
                        <span class="truncate">
                          {{ country?.name }}
                        </span>
                      </div>
                    </ng-template>

                    <!-- Liste des pays -->
                    <ng-template pTemplate="item" let-country>
                      <div class="export-dropdown-option">
                        <!-- Tous les pays -->
                        <span
                          *ngIf="country?.isAll"
                          class="export-location-icon"
                        >
                          🌍
                        </span>

                        <!-- Drapeau -->
                        <span
                          *ngIf="!country?.isAll && country?.isoCode"
                          class="fi"
                          [ngClass]="'fi-' + country.isoCode.toLowerCase()"
                        >
                        </span>

                        <!-- Nom -->
                        <span class="truncate">
                          {{ country?.name }}
                        </span>
                      </div>
                    </ng-template>
                  </p-dropdown>
                </div>

                <!-- COHORTE -->
                <div>
                  <label
                    class="block text-xs font-semibold text-gray-700 mb-1.5"
                  >
                    Cohorte
                  </label>

                  <select
                    [(ngModel)]="exportCohorte"
                    [disabled]="
                      !selectedExportCountry ||
                      selectedExportCountry.isAll === true
                    "
                    class="w-full px-3 py-2.5 text-sm border border-gray-300 rounded-lg bg-white disabled:bg-gray-100 disabled:text-gray-400 disabled:cursor-not-allowed focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  >
                    <!-- Valeur par défaut -->
                    <option [ngValue]="null">Toutes les cohortes</option>

                    <!-- Cohortes filtrées selon le pays -->
                    <option
                      *ngFor="let cohorte of filteredExportCohortes"
                      [ngValue]="cohorte"
                    >
                      {{ cohorte }}
                    </option>
                  </select>

                  <!-- Message si aucun pays n'est sélectionné -->
                  <p
                    *ngIf="
                      !selectedExportCountry ||
                      selectedExportCountry.isAll === true
                    "
                    class="text-[11px] text-gray-400 mt-1"
                  >
                    Sélectionnez un pays pour choisir une cohorte.
                  </p>
                </div>

                <!-- ==================== RÉGION ==================== -->
                <div>
                  <label class="block text-xs font-medium text-gray-600 mb-1.5">
                    Région
                  </label>

                  <p-dropdown
                    [options]="exportRegionOptions"
                    [(ngModel)]="selectedExportRegionOption"
                    optionLabel="name"
                    [disabled]="
                      !selectedExportCountry ||
                      selectedExportCountry.isAll === true
                    "
                    [filter]="true"
                    filterBy="name"
                    filterPlaceholder="Rechercher une région..."
                    [showClear]="false"
                    appendTo="body"
                    class="export-dropdown"
                    styleClass="export-dropdown-control"
                    (onChange)="onExportRegionSelected($event)"
                  >
                    <!-- Région sélectionnée -->
                    <ng-template pTemplate="selectedItem" let-region>
                      <div class="export-dropdown-value">
                        <!-- Drapeau du pays -->
                        <span
                          *ngIf="region?.isoCode"
                          class="fi"
                          [ngClass]="'fi-' + region.isoCode.toLowerCase()"
                        >
                        </span>

                        <!-- Globe -->
                        <span
                          *ngIf="!region?.isoCode"
                          class="export-location-icon"
                        >
                          🌍
                        </span>

                        <!-- Nom -->
                        <span class="truncate">
                          {{ region?.name || "Toutes les régions" }}
                        </span>
                      </div>
                    </ng-template>

                    <!-- Liste des régions -->
                    <ng-template pTemplate="item" let-region>
                      <div class="export-dropdown-option">
                        <!-- Drapeau -->
                        <span
                          *ngIf="region?.isoCode"
                          class="fi"
                          [ngClass]="'fi-' + region.isoCode.toLowerCase()"
                        >
                        </span>

                        <!-- Globe -->
                        <span
                          *ngIf="!region?.isoCode"
                          class="export-location-icon"
                        >
                          🌍
                        </span>

                        <!-- Nom -->
                        <span class="truncate">
                          {{ region?.name }}
                        </span>
                      </div>
                    </ng-template>
                  </p-dropdown>

                  <!-- Message -->
                  <p
                    *ngIf="
                      !selectedExportCountry ||
                      selectedExportCountry.isAll === true
                    "
                    class="text-[11px] text-gray-400 mt-1"
                  >
                    Sélectionnez un pays pour choisir une région.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <!-- FOOTER -->
          <!-- FOOTER -->
          <div
            class="px-4 sm:px-5 py-4 border-t bg-gray-50 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3"
          >
            <!-- RÉINITIALISER -->
            <button
              type="button"
              (click)="resetExportFilters()"
              class="inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg text-xs font-medium text-gray-500 hover:text-red-600 hover:bg-red-50 transition self-start sm:self-auto"
            >
              <svg
                class="w-3.5 h-3.5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1.8"
                  d="M3 12a9 9 0 1 0 3-6.7"
                />

                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1.8"
                  d="M3 4v5h5"
                />
              </svg>

              Réinitialiser
            </button>

            <!-- ACTIONS -->
            <div
              class="flex flex-col-reverse sm:flex-row gap-2 w-full sm:w-auto"
            >
              <!-- ANNULER -->
              <button
                type="button"
                (click)="exportMenuOpen = false"
                class="w-full sm:w-auto px-3 py-2 text-sm border border-gray-300 rounded-lg bg-white hover:bg-gray-50 transition"
              >
                Annuler
              </button>

              <!-- EXPORT EXCEL NORMAL -->
              <button
                type="button"
                (click)="exportStudents(false)"
                [disabled]="!hasExportFilter() || exportLoading !== null"
                class="w-full sm:w-auto flex items-center justify-center gap-2 px-4 py-2 text-sm text-white bg-blue-600 rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition"
              >
                <svg
                  *ngIf="exportLoading === 'normal'"
                  class="w-4 h-4 animate-spin"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    class="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    stroke-width="4"
                  ></circle>

                  <path
                    class="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                  ></path>
                </svg>

                {{
                  exportLoading === "normal"
                    ? "Export..."
                    : "Exporter avec doublons"
                }}
              </button>

              <!-- EXPORT EXCEL SANS DOUBLONS -->
              <button
                type="button"
                (click)="exportStudents(true)"
                [disabled]="!hasExportFilter() || exportLoading !== null"
                class="w-full sm:w-auto flex items-center justify-center gap-2 px-4 py-2 text-sm text-white bg-green-600 rounded-lg hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed transition"
              >
                <svg
                  *ngIf="exportLoading === 'distinct'"
                  class="w-4 h-4 animate-spin"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    class="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    stroke-width="4"
                  ></circle>

                  <path
                    class="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                  ></path>
                </svg>

                {{
                  exportLoading === "distinct"
                    ? "Export..."
                    : "Exporter Sans doublons"
                }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- CHIPS FILTRES ACTIFS -->
    <div *ngIf="activeFiltersCount > 0" class="flex flex-wrap gap-2 px-3 pb-3">
      <span
        *ngIf="viewMode !== 'ALL'"
        class="flex items-center gap-1 pl-2.5 pr-1.5 py-1 text-xs bg-blue-50 text-blue-700 rounded-full"
      >
        {{ modeLabels[viewMode] }}
        <button
          (click)="setMode('ALL')"
          class="hover:bg-blue-100 rounded-full p-0.5"
        >
          ✕
        </button>
      </span>

      <span
        *ngIf="selectedCourseType"
        class="flex items-center gap-1 pl-2.5 pr-1.5 py-1 text-xs bg-purple-50 text-purple-700 rounded-full"
      >
        {{ selectedCourseType }}
        <button
          (click)="selectedCourseType = null; onCourseTypeChange()"
          class="hover:bg-purple-100 rounded-full p-0.5"
        >
          ✕
        </button>
      </span>

      <span
        *ngIf="selectedCertificateId && selectedCertificateId !== '-1'"
        class="flex items-center gap-1 pl-2.5 pr-1.5 py-1 text-xs bg-green-50 text-green-700 rounded-full"
      >
        {{ selectedCertificateId }}
        <button
          (click)="selectedCertificateId = '-1'; onCertificateChange()"
          class="hover:bg-green-100 rounded-full p-0.5"
        >
          ✕
        </button>
      </span>

      <button
        (click)="resetFilters()"
        class="text-xs text-gray-500 hover:text-red-600 underline px-1"
      >
        Tout réinitialiser
      </button>
    </div>

    <!-- PANNEAU FILTRES (repliable) -->
    <div *ngIf="filtersOpen" class="border-t bg-gray-50 p-3 sm:p-4">
      <div class="flex flex-col sm:flex-row sm:items-center gap-3">
        <!-- Mode : boutons desktop / select mobile -->
        <div
          class="hidden sm:flex flex-wrap gap-2 bg-gray-100 p-1 rounded-lg flex-1 min-w-0"
        >
          <button
            class="px-2 py-2 text-xs rounded-md whitespace-nowrap transition"
            [class.bg-white]="viewMode === 'ALL'"
            [class.shadow-sm]="viewMode === 'ALL'"
            (click)="setMode('ALL')"
          >
            Tous
          </button>
          <button
            class="px-2 py-2 text-xs rounded-md whitespace-nowrap transition"
            [class.bg-white]="viewMode === 'FEMALE'"
            [class.shadow-sm]="viewMode === 'FEMALE'"
            (click)="setMode('FEMALE')"
          >
            Femmes
          </button>
          <button
            class="px-2 py-2 text-xs rounded-md whitespace-nowrap transition"
            [class.bg-white]="viewMode === 'MALE'"
            [class.shadow-sm]="viewMode === 'MALE'"
            (click)="setMode('MALE')"
          >
            Hommes
          </button>
          <button
            class="px-2 py-2 text-xs rounded-md whitespace-nowrap transition"
            [class.bg-white]="viewMode === 'CERTIFIED'"
            [class.shadow-sm]="viewMode === 'CERTIFIED'"
            (click)="setMode('CERTIFIED')"
          >
            Certifiés
          </button>
          <button
            class="px-2 py-2 text-xs rounded-md whitespace-nowrap transition"
            [class.bg-white]="viewMode === 'ENHANCED'"
            [class.shadow-sm]="viewMode === 'ENHANCED'"
            (click)="setMode('ENHANCED')"
          >
            Renforcés
          </button>
          <button
            class="px-2 py-2 text-xs rounded-md whitespace-nowrap transition"
            [class.bg-white]="viewMode === 'INSERES'"
            [class.shadow-sm]="viewMode === 'INSERES'"
            (click)="setMode('INSERES')"
          >
            En situation d'emploi
          </button>
        </div>

        <select
          class="sm:hidden w-full px-3 py-2.5 text-sm border rounded-lg bg-white"
          [(ngModel)]="viewMode"
          (change)="setMode(viewMode)"
        >
          <option value="ALL">Tous</option>
          <option value="FEMALE">Femmes</option>
          <option value="MALE">Hommes</option>
          <option value="CERTIFIED">Certifiés</option>
          <option value="ENHANCED">Renforcés</option>
          <option value="INSERES">En situation d'emploi</option>
        </select>

        <!-- Type de parcours + certificat -->
        <div class="flex flex-col sm:flex-row gap-2 sm:w-auto sm:shrink-0">
          <select
            class="w-full sm:w-44 px-3 py-2.5 text-sm border rounded-lg bg-white"
            [(ngModel)]="selectedCourseType"
            (change)="onCourseTypeChange()"
          >
            <option [ngValue]="null">Tous les parcours</option>
            <option *ngFor="let type of courseTypeOptions" [value]="type">
              {{ type }}
            </option>
          </select>

          <select
            class="w-full sm:w-44 px-3 py-2.5 text-sm border rounded-lg bg-white disabled:bg-gray-100 disabled:text-gray-400"
            [(ngModel)]="selectedCertificateId"
            (change)="onCertificateChange()"
            [disabled]="!selectedCourseType"
          >
            <option [ngValue]="null">
              Tous les certificats {{ viewMode }}
            </option>
            <option
              *ngFor="let certifcate of certifcateOption"
              [value]="certifcate.name"
            >
              {{ certifcate.name }}
            </option>
          </select>
        </div>
      </div>
    </div>
  </div>

  <!-- TABLE  -->
  <div
    class="bg-white border rounded-xl shadow-sm overflow-hidden tab-apprenants"
  >
    <table mat-table [dataSource]="dataSource" class="w-full">
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Nom & Prénom</th>
        <td
          mat-cell
          *matCellDef="let row"
          data-label="Nom"
          class="font-semibold"
        >
          {{ row.fullname }}
        </td>
      </ng-container>

      <ng-container matColumnDef="sexe">
        <th mat-header-cell *matHeaderCellDef>Genre</th>
        <td mat-cell *matCellDef="let row" data-label="Genre">
          <span
            class="px-2 py-1 text-xs rounded-lg"
            [class.bg-blue-100]="row.sexe === 'M'"
            [class.text-blue-700]="row.sexe === 'M'"
            [class.bg-pink-100]="row.sexe === 'F'"
            [class.text-pink-700]="row.sexe === 'F'"
          >
            {{ row.sexe || "N/A" }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef>Email</th>
        <td mat-cell *matCellDef="let row" data-label="Email">
          {{ row.email }}
        </td>
      </ng-container>

      <ng-container matColumnDef="nombrecours">
        <th mat-header-cell *matHeaderCellDef>Nombre de certificats</th>
        <td mat-cell *matCellDef="let row">
          {{ certificationData?.certificatNumber || "" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef class="text-center">Action</th>
        <td
          mat-cell
          *matCellDef="let row"
          data-label="Action"
          class="text-center action-cell"
        >
          <button
            (click)="openDetails(row)"
            class="w-9 h-9 sm:w-10 sm:h-10 rounded-xl hover:bg-gray-100 active:scale-95 transition inline-flex items-center justify-center"
          >
            <svg
              class="w-5 h-5 text-gray-700"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-width="1.5"
                d="M2.036 12.322C3.423 7.51 7.36 4.5 12 4.5s8.573 3.007 9.963 7.178c.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5S3.423 16.49 2.036 12.322Z"
              />
              <path
                stroke-width="1.5"
                d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
              />
            </svg>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <div
      *ngIf="!(dataSource.filteredData ?? dataSource.data)?.length"
      class="p-6 text-center text-sm text-gray-500"
    >
      Aucun apprenant trouvé.
    </div>

    <!-- PAGINATOR -->
    <div class="border-t p-2">
      <mat-paginator
        [length]="totalElements"
        [pageSize]="pageSize"
        [pageIndex]="currentPage"
        [pageSizeOptions]="pageSizeOptions"
        showFirstLastButtons
      >
      </mat-paginator>
    </div>
  </div>
</div>

<div
  *ngIf="popupVisible"
  class="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-end sm:items-center justify-center z-50 p-2 sm:p-4"
>
  <div
    class="bg-white w-full sm:max-w-4xl rounded-2xl shadow-xl overflow-hidden max-h-[95vh] overflow-y-auto"
  >
    <!-- HEADER -->
    <div class="flex justify-between items-center px-4 sm:px-6 py-3 border-b">
      <h2 class="text-base sm:text-lg font-semibold">
        {{ ligneDetails?.firstname }} {{ ligneDetails?.lastname }}
      </h2>

      <button
        (click)="closeModal()"
        class="text-gray-500 hover:text-black text-xl"
      >
        ✕
      </button>
    </div>

    <!-- BODY -->
    <div
      class="p-4 sm:p-6 grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 text-sm"
    >
      <div class="p-3 bg-gray-50 rounded-lg">
        <div class="text-gray-500 text-xs">Nom complet</div>
        <div class="font-medium">
          {{ ligneDetails?.lastname }} {{ ligneDetails?.firstname }}
        </div>
      </div>

      <div class="p-3 bg-gray-50 rounded-lg">
        <div class="text-gray-500 text-xs">Email</div>
        <div class="font-medium break-all">
          {{ ligneDetails?.email }}
        </div>
      </div>

      <div class="p-3 bg-gray-50 rounded-lg">
        <div class="text-gray-500 text-xs">Genre</div>
        <div class="font-medium">{{ ligneDetails?.sexe }}</div>
      </div>

      <div class="p-3 bg-gray-50 rounded-lg">
        <div class="text-gray-500 text-xs">Ville</div>
        <div class="font-medium">{{ ligneDetails?.city }}</div>
      </div>
      <div class="p-3 bg-gray-50 rounded-lg mt-2">
        <div class="text-gray-500 text-xs">Nombre de certificats</div>
        <div class="font-medium">
          {{ certificationData?.certificatNumber || 0 }}
        </div>
      </div>
    </div>

    <!-- CERTIFICATS TABLE -->
    <table
      class="w-full min-w-[700px] text-sm border rounded-lg overflow-hidden"
    >
      <thead class="bg-gray-100 text-left">
        <tr>
          <th class="p-3">Nom certificat</th>
          <th class="p-3">Id certificat</th>
          <th class="p-3">Cohorte</th>
          <th class="p-3">Certifié</th>
          <th class="p-3">Renforcé</th>
          <th class="p-3">Inséré</th>
        </tr>
      </thead>

      <tbody>
        <tr
          *ngFor="let c of certificationRows"
          class="border-t hover:bg-gray-50"
        >
          <td class="p-3">
            {{ c.nameCertificate || "-" }}
          </td>

          <td class="p-3">
            {{ c.idCertificate || "-" }}
          </td>

          <td class="p-3">
            {{ c.cohort || "-" }}
          </td>

          <!-- CERTIFIÉ -->
          <td class="p-3">
            <span
              class="px-2 py-1 rounded-full text-xs font-medium"
              [class.bg-green-100]="c.certified"
              [class.text-green-700]="c.certified"
            >
              {{ c.certified ? "Oui" : "-" }}
            </span>
          </td>

          <td class="p-3">
            <span
              class="px-2 py-1 rounded-full text-xs font-medium"
              [class.bg-blue-100]="c.enhanced"
              [class.text-blue-700]="c.enhanced"
            >
              {{ c.enhanced ? "Oui" : "-" }}
            </span>
          </td>

          <td class="p-3">
            <span
              class="px-2 py-1 rounded-full text-xs font-medium"
              [class.bg-purple-100]="c.inserted"
              [class.text-purple-700]="c.inserted"
            >
              {{ c.inserted ? "Oui" : "-" }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- FOOTER -->
    <div class="px-4 sm:px-6 py-4 border-t flex justify-end">
      <button
        (click)="closeModal()"
        class="w-full sm:w-auto px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600"
      >
        Fermer
      </button>
    </div>
  </div>
</div>
